<template>
  <div v-if="me">
    <div class="col-xs-12 col-sm-12 col-md-9 col-xl-6 col-xs-offset-0 col-sm-offset-0 col-md-offset-3 col-lg-offset-3 toppad">
      <div class="panel panel-info">
        <div class="panel-heading">
          <h3 class="panel-title">{{ me.firstName }} {{ me.lastName }}</h3>
        </div>
        <div class="panel-body">
          <div class="row">
            <div class="col-md-3 col-lg-3 " align="center">
              <img width="100px" alt="Profile Pic" src="https://www.gravatar.com/avatar/00000000000000000000000000000000?d=https%3A%2F%2Fleaf.ai%2Fimg%2Flogo.png&s=100" class="img-circle img-responsive mt-5">
            </div>

            <div class="col-md-9 col-lg-9">
              <table class="table table-borderless">
                <tbody>
                  <tr>
                    <td>First Name</td>
                    <td>
                      <b-form-input name="rule-firstname" v-model.trim.lazy="me.firstName" v-validate="'required'" :class="{'is-invalid': errors.has('rule-firstname') }" />
                      <b-form-text class="is-invalid help" v-show="errors.has('rule-firstname')">
                        {{ errors.first('rule-firstname') }}
                      </b-form-text>
                    </td>
                  </tr>
                  <tr>
                    <td>Last Name</td>
                    <td>
                      <b-form-input name="rule-lastname" v-model.trim.lazy="me.lastName" v-validate="'required'" :class="{'is-invalid': errors.has('rule-lastname') }" />
                      <b-form-text class="is-invalid help" v-show="errors.has('rule-lastname')">
                        {{ errors.first('rule-lastname') }}
                      </b-form-text>
                    </td>
                  </tr>
                  <tr>
                    <td>Email</td>
                    <td>
                      <b-form-input name="email" v-model.trim.lazy="me.email" v-validate="'required|email'" :class="{'is-invalid': errors.has('email') }" />
                      <b-form-text class="is-invalid help" v-show="errors.has('email')">
                        {{ errors.first('email') }}
                      </b-form-text>
                    </td>
                  </tr>
                  <tr>
                    <td>Phone Number</td>
                    <td>
                      <b-form-input name="phone" v-model.trim.lazy="me.phoneNumber" v-validate="'phoneNumber'" :class="{'is-invalid': errors.has('phone') }" />
                      <b-form-text class="is-invalid help" v-show="errors.has('phone')">
                        {{ errors.first('phone') }}
                      </b-form-text>
                    </td>
                  </tr>

                  <tr>
                    <td>Password</td>
                    <td>
                      <router-link :to="{ name: 'Change Password' }">Change Password</router-link>
                    </td>
                  </tr>

                  <tr>
                    <td></td>
                    <td>
                      <b-button class="rule-submit" type="submit" variant="success" @click.prevent="saveProfile"><i class="fas fa-check"></i><span class="pl-2">Save</span></b-button>
                    </td>
                  </tr>

                </tbody>
              </table>

            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import { Validator } from 'vee-validate'
import { USER_QUERY, UPDATE_USER_MUTATION } from '@/constants/graphql'
import PhoneNumber from 'awesome-phonenumber'

const phoneNumber = {
  getMessage: () => `Not a valid phone number`,
  validate (value) {
    return new Promise(resolve => {
      let phone = new PhoneNumber(value, 'US');
      resolve({ valid: phone.isValid() })
    })
  }
}
Validator.extend('phoneNumber', phoneNumber)

export default {
  name: 'UserProfile',
  data () {
    return {
    }
  },
  methods: {
    saveProfile () {
      this.$validator.validateAll().then((result) => {
        if (result) {

          let data = { ...this.me }
          delete data.id

          this.$apollo.mutate({
            mutation: UPDATE_USER_MUTATION,
            variables: { data, id: this.me.id }
          }).then(() => {
            this.$swal.fire({ icon: 'success', title: 'Success! Profile Updated' })
            this.$emit('saved')
          }).catch(() => {
            // handled by global onError handler but still need to catch in the promise
          })

        }
      })
    }
  },
  components: {
  },
  apollo: {
    me: {
      query: USER_QUERY
    }
  }
}
</script>

<style scoped>
</style>
